<template>
  <b-container fluid>
    <b-breadcrumb
      v-if="userType == 3"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{$t("dashboard")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="!isDirectLink"
        to="/employee-complaints"
      >{{$t("complaints.myComplaints")}}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{$t("complaints.complaintForm")}}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoading"
      class="text-center"
      small
    />
    <b-container
      fluid
      class="m-0"
      v-if="!isLoading"
    >
      <b-row v-if="showingIntro && !complaintViewPage && form.isShowFormIntro">
        <b-col
          cols="8"
          offset="2"
        >
          <div class="align-middle my-5">
            <h3>
              {{
                form.formTitle
                  ? form.formTitle[selectedLanguage || "english"]
                  : "No Title"
              }}
            </h3>
            <div style="height: calc(100vh - 395px); overflow: auto">
              <!-- <p v-html="pageIntroText"></p> -->
              <p v-html="sanitizeHtml(
                  form.formIntroText
                    ? form.formIntroText[selectedLanguage || 'english']
                    : 'No Title'
                )"></p>
            </div>
            <b-form-checkbox
              class="text-center my-3"
              v-model="userConsent"
            >{{
              $t("questionnaires.consent")
            }}</b-form-checkbox>
            <b-button
              variant="outline-danger"
              class="mr-2"
              to="/dashboard"
            >{{
              $t("questionnaires.backToDashboard")
            }}</b-button>
            <b-button
              variant="outline-success"
              :disabled="!userConsent"
              class="mr-2"
              @click="onClickProceed()"
            >{{ $t("questionnaires.proceed") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col
          :cols="complaintViewPage ? '12' : '10'"
          :offset="complaintViewPage ? '' : '1'"
        >
          <b-card>
            <div style="height: calc(100vh - 245px); overflow: hidden">
              <b-row>
                <b-col class="text-center">
                  <h3 class="mt-2">
                    {{
                      form.formTitle
                        ? form.formTitle[selectedLanguage || "english"]
                        : "No Title"
                    }}
                  </h3>
                  <p>
                    {{
                      form.formDescription
                        ? form.formDescription[selectedLanguage || "english"]
                        : "No Description"
                    }}
                  </p>
                </b-col>
              </b-row>

              <div
                id="scrollspy"
                class="preview-scrollable-wrapper p-3"
              >
                <div
                  v-if="form.formSection.length"
                  id="element"
                  style="background-color: #f4f4f4"
                >
                  <b-form v-if="!isLoading">
                    <SectionContainer
                      v-for="(sectionData, index) in form.formSection"
                      :id="'section_' + index"
                      :isDisabled="isDisabled"
                      :isPreview="true"
                      :selectedLanguage="selectedLanguage"
                      :sectionData="sectionData"
                      :inputType="sectionData.inputType"
                      :key="index"
                      :counter="index"
                    />
                  </b-form>
                </div>
              </div>
            </div>
            <b-row class="mt-3">
              <b-col
                cols="6"
                class="text-left"
              >
                <a
                  v-if="form.formSection.length"
                  href="#"
                  class="goto-top-btn btn"
                  v-scroll-to="{
                    el: '#scrollspy',
                    container: '#scrollspy',
                    duration: 300,
                    easing: 'linear',

                    force: true,

                    x: false,
                    y: true,
                  }"
                >
                  <font-awesome-icon icon="angle-up" />
                </a>
              </b-col>

              <b-col>
                <b-button-group class="float-right">
                  <b-button
                    v-if="
                      form.formSection.length &&
                      taskStatus != 4 &&
                      !complaintViewPage
                    "
                    variant="outline-success"
                    @click="onValidateSubmit"
                  >{{ $t("submitText") }}</b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- review modal -->
      <b-modal
        id="modal-1"
        modal-header-close="No"
        :ok-title="$t('submitText')"
        :cancel-title="$t('cancelBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('complaints.submitModalTitle')"
        @ok="onSubmit"
      >
        <p>{{ $t("complaintFormSubmitingMessage") }}</p>
        <p></p>
      </b-modal>

      <b-modal
        :title="$t('complaints.uploadFile')"
        v-model="showUploadModal"
        size="lg"
        scrollable
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
      >
        <div>
          <div
            class="text-center"
            v-if="!submiting && !responseSuccess"
          >
            <p>
              {{ $t("complaints.toServe") }}
            </p>
            <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              v-on:vdropzone-sending="sendingEvent"
              @vdropzone-success="vsuccess"
              :options="dropzoneOptions"
              :useCustomSlot="true"
              class="m-5 p-3"
              style="border: dashed 1px"
            >
              <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title">
                  {{ $t("complaints.dragDrop") }}
                </h3>
                <div class="subtitle">
                  {{ $t("complaints.clickToSelect") }}
                </div>
              </div>
            </vue-dropzone>
            <b-form-group
              label-cols-sm="4"
              label-cols-lg="3"
              :label="$t('complaints.displayName')"
            >
              <b-form-input
                type="text"
                v-model="uploadFileDisplayName"
                size="sm"
                :state="displayNameHasXss ? false : null"
              />
              <b-form-invalid-feedback>{{ $t( "createProfile.invalidInputMessage" ) }}</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div v-else-if="submiting && !responseSuccess">
            <p>{{ $t("complaints.uploading") }}</p>
            <b-spinner
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>
          <div v-else>
            <p class="my-2 text-center">
              {{ $t("complaints.uploadSuccessfull") }}
              <br />
            </p>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="float-right">
            <b-button
              class="mr-3"
              variant="outline-danger"
              v-if="!uploading"
              @click="skipUploadFiles"
            >{{ $t("complaints.skip") }}</b-button>
            <b-button
              variant="outline-success"
              v-if="!uploading && !responseSuccess"
              @click="uploadFileApiCall"
            >{{ $t("complaints.upload") }}</b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        id="modal-2"
        modal-header-close="No"
        ok-only
        :ok-title="$t('closeBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.formSubmittedModalTitle')"
        @ok="openDashboardPage"
      >
        <p>{{ $t("formSubmittedMessage") }}</p>
        <p></p>
      </b-modal>

      <b-alert
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000"
        variant="danger"
        dismissible
        solid
      >{{ $t("formValidationMessage") }}</b-alert>
    </b-container>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionContainer from "../../containers/SectionUserContainer";
import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../components/Dropzone/VueDropzone";
import { Helper, Validate } from "../../helpers";

export default {
  name: "EmployeeComplaintForm",
  components: {
    SectionContainer,
    AppLoader,
    VueDropzone,
  },
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          to: "/dashboard",
        },
        {
          text: "My Complaints",
          to: "/employee-complaints",
        },
        {
          text: "Complaint Form",
          to: "#",
        },
      ],
      isDirectLink: false,
      submiting: false,
      responseSuccess: false,
      uploading: false,
      showUploadModal: false,
      dropzoneOptions: {
        url: "",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
      },
      uploadFileDisplayName: null,
      isDisabled: 0,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      inValidElements: [],
      inValidSections: [],
      pageStatus: null,
      isAnonymous: null,
      complaintType: null,
      complaintCountry: null,
      commentValue: null,
      userType: null,
    };
  },

  mounted () {
    this.userType = localStorage.getItem( "userType" );
    this.$store.state.employeeDashboardTabIndex = 2;
    this.$store.state.validFields = true;
    let form_data = [];
    if ( this.complaintViewPage == true ) {
      form_data = this.formData;
      this.isDisabled = 1;
      this.getTaskForm( form_data );
    } else {
      this.getTaskForm( form_data );
    }
  },

  beforeDestroy () { },

  beforeRouteLeave ( to, from, next ) {
    let employeeIdActive = localStorage.getItem( "employeeId" );
    if (
      (this.$route.name == "userform" ||
      this.$route.name == "EmployeeComplaintFormPage") && employeeIdActive
    ) {
      if ( this.fromButton ) {
        next();
      } else {
        const answer = window.confirm( this.$t( "formLeaveAlertMessage" ) );
        if ( answer ) {
          this.$store.state.userFormSubmitArray = [];
          this.$store.state.getUserFormSubmitArray = [];
          this.onResetLocalData();
          next();
        } else {
          next( false );
        }
      }
    } else {
      next();
    }
  },

  computed: {
    displayNameHasXss () {
      return !Validate.noXSS( this.uploadFileDisplayName );
    },
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),

    ...mapState( {
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    } ),
  },

  watch: {
    selectedLanguage ( lang ) {
      this.updateTitles( lang );
    },
  },
  created () {
    EventBus.$on( "onDirectLink", ( value ) => {
      this.isDirectLink = true;
    } );
  },
  methods: {
    sanitizeHtml,
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["TOGGLE_LOADER"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    makeToast () {
      const h = this.$createElement;
      const vNodesMsg = h( "p", { class: ["text-center", "mb-0"] }, [
        h( "b-spinner", { props: { type: "grow", small: true } } ),
        this.$t( "toast.generatePDF" ),
        h( "b-spinner", { props: { type: "grow", small: true } } ),
      ] );
      this.$bvToast.toast( [vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      } );
    },
    makeToster ( tosterVarient, tosterMsg ) {
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    onClickProceed () {
      this.showingIntro = false;
    },

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
      localStorage.removeItem( "activeFormId" );
      localStorage.removeItem( "userConsent" );
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    initializeFormData () {
      this.$store.state.progressMaxValue = 0;
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        this.$store.state.progressMaxValue = this.$store.state.getUserFormSubmitArray.length;
        this.calculateProgressValue( this.$store.state.getUserFormSubmitArray );
      } else {
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep( this.form );
        tempForm.formSection.map( ( section, index ) => {
          section.formElements.map( ( element, elementIndex ) => {
            this.$store.state.progressMaxValue += 1;
            this.$store.state.userFormSubmitArray.push( {
              elements: [],
              sectionId: section.id,
              sectionIndex: section.index,
              elementIndex: elementIndex,
              elementId: element.id,
              elementInputType: element.inputType,
              elementTitle: element.label,
              elementTitleAbb: element.label,
              sectionTitle: section.abbreviationLabel || element.label,
              language: this.selectedLanguage,
              isMultiSelect: 0,
              selectedChart: element.selectedCharts || null,
              enableSelfReporting:
                ( element.configuration &&
                  parseInt( element.configuration.enableSelfReporting ) ) ||
                0,
            } );
          } );
        } );
      }
    },

    updateTitles ( lang ) {
      const dd = this.$store.state.userFormSubmitArray;
      let array2 = dd.map( ( a ) => {
        return ( a.language = lang );
      } );
    },

    calculateProgressValue ( array ) {
      const registerData = _.clone( this.$store.state.registerData );
      for ( let i = 0; i < array.length; i++ ) {
        if ( array[i].elements.length > 0 && array[i].elements[0].postValue ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.length
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].length &&
          array[i].elements[0][0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.phone
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
      }
      this.$store.state.registerData = registerData;
      let numkeys = Object.keys( registerData ).length;
      this.$store.state.progressValue = numkeys;
    },

    changeLanguage () {
      let tt = this.selected.toLowerCase();
      this.setLanguage( tt );
      this.TOGGLE_LOADER( 100 );
    },

    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      let taskdata = JSON.parse( localStorage.getItem( "taskFormData" ) );
      this.updateFormToStore( form );
    },

    updateFormToStore ( form ) {
      this.UPDATE_FORM( form );
    },

    onValidateSubmit () {
      EventBus.$emit( "onSubmitEndUserForm", "form submit" );
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    openDashboardPage () {
      this.$router.push( "/employee-complaints" );
    },

    checkForInValidFields () {
      let isValid = false;
      outerLoop: for (
        let i = 0;
        i < this.$store.state.form1.formSection.length;
        i++
      ) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x]
                .id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            EventBus.$emit( "OnInvalidFieldCatch", inValidData );
            this.showErrorToast = true;
            isValid = false;
            break outerLoop;
          }
          isValid = true;
        }
      }
      if ( isValid ) {
        this.onReviewSubmit();
      }
    },

    getInvalidFields () {
      this.inValidElements = [];
      this.inValidSections = [];
      for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            this.inValidElements.push(
              this.$store.state.form1.formSection[i].formElements[x]
            );
          }
        }
      }
    },

    onReviewSubmit () {
      if ( this.$store.state.validFields ) {
        this.showErrorToast = false;
        this.$bvModal.show( "modal-1" );
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit () {
      let form_data = this.$store.state.userFormSubmitArray;
      form_data.map( ( elementsData ) => {
        if (
          elementsData.elementTitle.english ==
          "Do you wish to have your details remain confidential?"
        ) {
          this.isAnonymous = elementsData.elements[0].postValue == "Yes" ? 1 : 0;
          // elementsData.elements.map( ( element ) => {
          //   this.isAnonymous = element.postValue == "Yes" ? 1 : 0;
          // } );
        }
        if ( elementsData.elementTitle.english == "Type of Complaint" ) {
          this.complaintType = elementsData.elements[0].postValue[0].text['english'];
          // elementsData.elements.map( ( element ) => {
          //   this.complaintType = element.postValue[0];
          // } );
        }
        if ( elementsData.elementTitle.english == "Country of Complaint" ) {
          this.complaintCountry = elementsData.elements[0].postValue[0]['country']['english'];
          // elementsData.elements.map( ( element ) => {
          //   this.complaintCountry = element.postValue[0]['country']['english'];
          // } );
        }
        if (
          elementsData.elementTitle.english ==
          "Please provide a detailed explanation of the complaint:"
        ) {
          this.commentValue = elementsData.elements[0].postValue;
          // elementsData.elements.map( ( element ) => {
          //   this.commentValue = element.postValue;
          // } );
        }
      } );
      await this.saveFormData();
    },

    async saveFormData () {
      let taskData = this.$store.state.userFormSubmitArray;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "post",
          "api/v1/complaints/create",
          {
            form_data: taskData,
            complaint_type: this.complaintType,
            comment: this.commentValue,
            meta_data:{country:this.complaintCountry},
            is_anonymous: this.isAnonymous,
            user_id: localStorage.getItem( "userId" ),
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        if ( result.data.status == 1 ) {
          this.dropzoneOptions.url =
            process.env.VUE_APP_API_URL +
            "api/v1/complaints/files/upload/" +
            result.data.complaints.id;
          this.showUploadModal = true;
        }
        else {
          this.makeToster( 'danger', result.data.message );
        }
      } catch {
        this.fromButton = true;
        this.makeToster( 'danger', 'Oops! Something Went Wrong' );
      }
    },

    onScrollClick ( index ) {
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById( id ).scrollIntoView( { behavior: "smooth" } );
    },

    async getTaskForm ( form_data ) {
      localStorage.removeItem( "activeFormSchema" );
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/forms/list",
        {
          type: "complaint",
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.form ) {
        let form_schema = result.data.form.schema;
        localStorage.setItem( "activeFormSchema", form_schema );
        this.setUserFormSchemaToStore();
        this.initializeFormData();
      }
    },
    uploadFileApiCall () {
      if ( this.displayNameHasXss ) {
        return;
      }
      if ( this.$refs.myVueDropzone.getQueuedFiles().length > 0 ) {
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    vsuccess () {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      // this.makeToster('success','Your complaint has been filed successfully.');
      // this.makeToster('success','Your file has been successfully uploaded and is now processed.');
      this.$refs.myVueDropzone.removeAllFiles();
      this.resetUploadModal();
      this.fromButton = true;
      this.$bvModal.show( "modal-2" );
    },
    sendingEvent ( file, xhr, formData ) {
      let userId = localStorage.getItem( "userId" );
      let employeeId = localStorage.getItem( "employeeId" );
      // let userId = this.isAnonymous == 1 ? 0 : localStorage.getItem( "userId" );
      formData.append( "employee_id", this.isAnonymous == 1 ? 0 : employeeId );
      formData.append( "displayName", this.uploadFileDisplayName );
      formData.append( "user_id", this.isAnonymous == 1 ? 0 : userId );
    },
    resetUploadModal () {
      this.isAnonymous = null;
      this.complaintType = null;
      this.commentValue = null;
      this.complaintCountry = null;
      this.isLoadingComplaintsFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
    },
    skipUploadFiles () {
      this.isLoadingComplaintsFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
      this.fromButton = true;
      this.$bvModal.show( "modal-2" );
      // this.$router.push("/employee-complaints");
    },
  },
  props: {
    complaintViewPage: Boolean,
    formData: Array,
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 325px);
  /* height:400px */
}
a.goto-top-btn {
  border-color: #3b3e66 !important;
  color: #3b3e66 !important;
  background-color: #fff;
}
a.goto-top-btn:hover {
  color: #fff !important;
  border-color: #3b3e66 !important;
  background-color: #3b3e66;
}
.selectPicket {
  width: 350px;
}
</style>

